import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { notification } from 'antd';
import reject from 'lodash/reject';
import { reduxForm, reset } from 'redux-form';
import { pending, rejected } from 'redux-saga-thunk';
import { fromEntities, fromResource } from '../store/selectors';
import { modalHide, modalShow } from '../store/modal/actions';
import { isOpen } from '../store/modal/selectors';
import ProductListModal from '../components/organisms/ProductListModal';
import { createValidator, required } from '../services/validation';
import { resourceCreateRequest, resourceListReadRequest } from '../store/resource/actions';

class ProductListModalContainer extends Component {
  componentDidUpdate = prevProps => {
    if (this.props.visible && !prevProps.visible) {
      this.props.getProductList().catch(e =>
        notification.error({
          message: 'Error',
          description: typeof e === 'string' ? e : 'Could not get list of products.',
          duration: 0,
        })
      );
    }
  };

  render = () => <ProductListModal {...this.props} />;
}

const mapStateToProps = (
  { modal, ...state },
  {
    match: {
      params: { campaignId },
    },
  }
) => {
  const fullList = fromEntities.getList(
    state,
    'advertiserAdProduct',
    fromResource.getList(state, 'advertiserAdProduct')
  );

  const inHandList = fromEntities.getList(
    state,
    'advertiserAdInhand',
    fromResource.getList(state, 'advertiserAdInhand')
  );

  const productList = reject(fullList, p => inHandList.find(x => x.product_id === p.product_id));

  return {
    campaign: fromEntities.getDetail(state, 'advertiserCampaign', campaignId),
    productList,
    rejected: rejected(state, 'advertiserAdProductListRead'),
    loading: pending(state, 'advertiserAdProductListRead'),
    visible: isOpen(modal, 'list-inhand-product'),
  };
};

const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { lineItemId },
    },
  }
) => ({
  addProduct: id =>
    dispatch(
      resourceCreateRequest(
        'advertiser-ad/:lineItemId/inhand',
        { lineItemId },
        { product_id: parseInt(id, 10) }
      )
    ),
  getProductList: () =>
    dispatch(
      resourceListReadRequest(
        'advertiser-ad/:lineItemId/product',
        { page_size: 100 },
        { lineItemId }
      )
    ),
  show: () => dispatch(modalShow('list-inhand-product')),
  onCancel: () => dispatch(modalHide('list-inhand-product')),
});

const onSubmit = (values, dispatch, props) => {
  const productIds = Object.keys(values);

  return Promise.all(productIds.map(props.addProduct))
    .then(() => {
      props.onCancel();
      dispatch(reset('ProductListModal'));
    })
    .catch(e =>
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Could not add products.',
        duration: 0,
      })
    );
};

const validate = createValidator({
  productId: [required],
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    destroyOnUnmount: false,
    enableReinitialize: true,
    form: 'ProductListModal',
    onSubmit,
    validate,
  })
)(ProductListModalContainer);
